const mEditionProductAutorespondersListsModalDelete = {
  mEditionProductAutorespondersListsModalDelete: {
    alerts: {
      deleteProductoAutoresponderLista: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'La lista de autoresponder asociada se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará la asociación de la lista de autoresponder',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Lista'
  }
}

export default mEditionProductAutorespondersListsModalDelete
